import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const STYLE = {
    container : {
        width: '100%',
        backgroundColor: '#FEE500',
        border: 'none',
        borderRadius: '12px',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        minHeight: '48px',
        fontSize: '15px',
        fontWeight: '600',
        color: '#191919',
        marginBottom: '20px',
    },
    logo : {
        width: '18px',
        height: 'auto',
        marginRight: '8px'
    }
}

const KakaoLogin = (props) => {
  const navigate = useNavigate();
  const KAKAO_JS_KEY = '4a1b04fc8dc5ad0d5bebd75274527a5c';
  // const KAKAO_JS_KEY = 'c663838444ba8175fbd0729916bcb877';

  // 카카오 SDK 초기화
  useEffect(() => {
    if (!window.Kakao) {
      const script = document.createElement('script');
      script.src = 'https://developers.kakao.com/sdk/js/kakao.min.js';
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.Kakao.init(KAKAO_JS_KEY);
        console.log('Kakao SDK initialized:', window.Kakao.isInitialized());
      };
    } else if (!window.Kakao.isInitialized()) {
      window.Kakao.init(KAKAO_JS_KEY);
      console.log('Kakao SDK initialized:', window.Kakao.isInitialized());
    }
  }, [KAKAO_JS_KEY]);

  const handleLogin = () => {
    window.Kakao.Auth.login({
      success: (response) => {
        const accessToken = response.access_token;
        props.loginSuccessCallback(accessToken);
      },
      fail: (error) => {
        console.error('Kakao login failed:', error);
        navigate('/login');
      },
    });
  };

  return (
    <button
      onClick={handleLogin}
      style={STYLE.container}
      aria-label="카카오 로그인"
    >
      <img
        src="/static/img/logo/kakao.png"
        alt="Kakao Symbol"
        style={STYLE.logo}
      />
      <span>카카오 로그인</span>
    </button>
  );
};

export default KakaoLogin;